import { observable, makeObservable, action } from 'mobx';
// 代码改造---未使用
class PreQuestionStore {
    constructor() {
        makeObservable(this);
    }
    @observable canClick = true;
    @action
    setCanClick = (flag) => {
        this.canClick = flag;
    };
}
export default new PreQuestionStore();
